import { gql } from '@apollo/client';

export const CONTENT_TAGS_USAGE = gql`
  query ContentTagsUsage($contentTagIds: [MongoObjectId!]!) {
    contentTagUsage(contentTagIds: $contentTagIds) {
      coreWord {
        listening
        writing
        oral
        reading
        total
      }
      coreSentence {
        listening
        writing
        oral
        reading
        total
      }
      topic {
        listening
        writing
        oral
        reading
        total
      }
      quiz {
        listening
        writing
        oral
        reading
        total
      }
      presentation {
        listening
        writing
        oral
        reading
        total
      }
      coreItemsIWGT {
        listening
        writing
        oral
        reading
        total
      }
      allContent {
        listening
        writing
        oral
        reading
        total
      }
    }
  }
`;

export const FETCH_CONTENT_TAG_TREE = gql`
  query contentTagTree($displayOptions: ContentTagDisplayOptions, $viewAsOrgId: MongoObjectId) {
    contentTagTree(displayOptions: $displayOptions, viewAsOrgId: $viewAsOrgId) {
      topLevelNodes
      allNodes
      globalNodes {
        curriculums
        meeoppTopics
      }
    }
  }
`;

export const CREATE_CONTENT_TAG = gql`
  mutation createContentTag(
    $contentTagInput: ContentTagInput!
    $translationInputs: [ContentTagTranslationInput!]
  ) {
    createContentTag(contentTagInput: $contentTagInput, translationInputs: $translationInputs) {
      _id
    }
  }
`;

export const EDIT_CONTENT_TAG = gql`
  mutation editContentTag(
    $contentTagId: MongoObjectId!
    $contentTagInput: ContentTagInput!
    $translationInputs: [ContentTagTranslationInput!]
  ) {
    editContentTag(
      contentTagId: $contentTagId
      contentTagInput: $contentTagInput
      translationInputs: $translationInputs
    ) {
      _id
    }
  }
`;

export const CONTENT_TAG_RELATION = gql`
  query contentTagRelation($contentTagId: MongoObjectId!, $category: ContentTagRelationCategory!) {
    contentTagRelation(contentTagId: $contentTagId, category: $category) {
      _id
      category
      type
      contentTagId
      relatedContentTagIds
    }
  }
`;
